import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AccountCircle from '@mui/icons-material/AccountCircle';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import { logout } from './authSlice';
import { wsDisconnect } from '../spectrasWebSocketServer/spectrasWebSocketServerSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';

const ProfileMenu = () => {
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.auth);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const dispatch = useAppDispatch();

  const handleMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(logout());
    dispatch(wsDisconnect());
    navigate('/');
  };

  const handleSettingsClicked = () => {
    handleClose();
    navigate('/user-settings');
  };

  return (
    <div>
      <IconButton onClick={handleMenu} size='large' color='inherit'>
        <AccountCircle />
      </IconButton>
      <Menu
        keepMounted
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={open}
        onClose={handleClose}
        style={{ zIndex: 999999 }}
      >
        <MenuItem>{user ? user.name : ''}</MenuItem>
        <Divider />
        <MenuItem onClick={handleSettingsClicked}>Settings</MenuItem>
        <MenuItem>
          <Link
            target='_blank'
            rel='noopener noreferrer'
            href='https://f002.backblazeb2.com/file/Software-Releases/Spectras/1.20.0/Spectras+User+Guide+1.21.pdf'
            underline='none'
          >
            User Guide
          </Link>
        </MenuItem>
        <MenuItem>
          <Link href='mailto:support@lptech.com' underline='none'>
            Contact Support
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            target='_blank'
            rel='noopener noreferrer'
            href='https://portal.lptapps.com/'
            underline='none'
          >
            Client Portal
          </Link>
        </MenuItem>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </div>
  );
};

export default ProfileMenu;
